import React from 'react';
import { Target, Clock, TrendingUp, Award, Shield, BarChart3 } from 'lucide-react';

const QualityMetrics = ({ facilityInfo, deviceInfo }) => {
  const { optimization } = deviceInfo;

  return (
    <div className="space-y-6">
      {/* Enhanced Header */}
      <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl p-6 text-white">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold flex items-center gap-3">
              <Award className="w-6 h-6" />
              Quality Metrics
            </h2>
            <p className="text-emerald-100 mt-1">Performance indicators and facility excellence</p>
          </div>
          <div className="text-right">
            <div className="text-3xl font-bold">A+</div>
            <div className="text-sm text-emerald-100">Overall Rating</div>
          </div>
        </div>
      </div>

      {/* Enhanced Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
              <Target className="w-6 h-6 text-white" />
            </div>
            <div className="flex items-center gap-1">
              <TrendingUp className="w-4 h-4 text-green-600" />
              <span className="text-sm text-green-600 font-medium">+12%</span>
            </div>
          </div>
          <h3 className="font-bold text-lg text-blue-900 mb-2">Incident Reduction</h3>
          <p className="text-3xl font-bold text-blue-800 mb-2">{facilityInfo.incidentReduction}%</p>
          <p className="text-sm text-blue-600">Since implementation</p>
        </div>
        
        <div className="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex items-center justify-center">
              <Clock className="w-6 h-6 text-white" />
            </div>
            <div className="flex items-center gap-1">
              <TrendingUp className="w-4 h-4 text-green-600" />
              <span className="text-sm text-green-600 font-medium">+8%</span>
            </div>
          </div>
          <h3 className="font-bold text-lg text-green-900 mb-2">Time Saved Daily</h3>
          <p className="text-3xl font-bold text-green-800 mb-2">{facilityInfo.timesSaved}</p>
          <p className="text-sm text-green-600">Through automation</p>
        </div>

        <div className="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center">
              <Shield className="w-6 h-6 text-white" />
            </div>
            <div className="flex items-center gap-1">
              <TrendingUp className="w-4 h-4 text-green-600" />
              <span className="text-sm text-green-600 font-medium">+15%</span>
            </div>
          </div>
          <h3 className="font-bold text-lg text-purple-900 mb-2">Safety Score</h3>
          <p className="text-3xl font-bold text-purple-800 mb-2">98.5%</p>
          <p className="text-sm text-purple-600">Patient safety rating</p>
        </div>

        <div className="bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center">
              <BarChart3 className="w-6 h-6 text-white" />
            </div>
            <div className="flex items-center gap-1">
              <TrendingUp className="w-4 h-4 text-green-600" />
              <span className="text-sm text-green-600 font-medium">+5%</span>
            </div>
          </div>
          <h3 className="font-bold text-lg text-orange-900 mb-2">Efficiency</h3>
          <p className="text-3xl font-bold text-orange-800 mb-2">94.2%</p>
          <p className="text-sm text-orange-600">Operational efficiency</p>
        </div>
      </div>
    </div>
  );
};

export default QualityMetrics;
